export default __webpack_public_path__ + "static/media/regreenbus_info_visual_03.48ccba77.png";